<template>
  <div id="LmUploadFilesBuilderUi" class="row">
    <LmTextInput
      class="col-12 col-md-4"
      v-model="component.componentProps.label"
      @input="onLabelChange($event)"
      :label="$t('title')"
      :placeholder="$t('title')"
      :help="$t('comp_title_help')"
    />
    <LmTextInput
      v-if="validateSuperUser"
      class="col-12 col-md-4"
      v-model="component.formObjectToSendToServerProperty"
      @input="$emit('input', component)"
      :label="$t('name')"
      :placeholder="$t('name')"
      :help="$t('comp_name_help')"
    />
    <LmSelect
      :id="id + 'css'"
      class="col-12 col-md-4"
      v-model="component.class"
      :options="{
        content: [
          {value: 'col-12 col-md-3',text: '25%'},
          {value: 'col-12 col-md-6', text: '50%'},
          {value: 'col-12 col-md-9', text: '75%'},
          {value: 'col-12 col-md-12', text: '100%'}
        ]
      }"
      :label="$t('desktop_view_width')"
      :help="$t('help_width_form_element')"
      @input="$emit('input', component)"
    />
    <LmNumberInputV2
      class="col-12 col-md-4"
      v-model="component.componentProps.dropzoneOptions.maxFiles"
      @input="$emit('input', component)"
      :label="$t('max_files_allow')"
      :placeholder="$t('max_files_allow')"
      :help="$t('max_files_allow_help')"
    />
    <LmSuperPowerSelectV2
      class="col-12"
      v-model="component.componentProps.dropzoneOptions.acceptedFiles"
      :options="fileExtensionsOptions"
      :label="$t('file_types_allow')"
      :placeholder="$t('file_types_allow')"
      :multiple="true"
    />
    <hr class="w-100 mx-2">
    <div class="col-12">
      <h5>{{ $t('validations') }}</h5>
      <div class="row align-items-center">
        <LmNumberInputV2
          :id="`max-size-${id}`"
          class="col-12 col-md-4"
          v-model="component.componentProps.dropzoneOptions.maxFilesize"
          @input="$emit('input', component)"
          :label="$t('file_max_size_allow')"
        />
        <LmCheckbox
          class="col-12 col-md-4"
          :labelSingle="$t('required')"
          v-model="validations.required"
          @input="$emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
        />
        <LmCheckbox
          class="col-12 col-md-4"
          :labelSingle="$t('only_unique_files')"
          v-model="component.componentProps.duplicateCheck"
          @input="$emit('input', component)"
        />
      </div>
    </div>
    <hr class="w-100 mx-2">
    <LmConditionalBuilderUi
      v-if="isVisibleCondition"
      class="col-12"
      :id="String(id)"
      :leftValueToCompareOptions="leftValueToCompareOptions"
      :visibilityDependOnConditions="visibilityDependOnConditions"
      @changeVisibilityDependOnConditions="component.visibilityDependOnConditions = $event"
      @input="$emit('input', component)"
    />
  </div>
</template>

<script>
import lmFormElementsBuilderUiMixin from '@/mixins/lmFormElementsBuilderUiMixin.js'

import LmTextInput from '@/components/form/elements/LmTextInput'
import LmNumberInputV2 from '@/components/form/elements/LmNumberInputV2'
import LmSelect from '@/components/form/elements/LmSelect'
import LmCheckbox from '@/components/form/elements/LmCheckbox'
import LmSuperPowerSelectV2 from '@/components/form/elements/LmSuperPowerSelectV2'

export default {
  name: 'LmUploadFilesBuilderUi',
  mixins: [lmFormElementsBuilderUiMixin],
  props: {
    isVisibleCondition: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      // Estas extensiones se pisan si existe la variable de entorno VUE_APP_FILE_EXTENSIONS_OPTIONS
      fileExtensionsOptions: ['JPG,PNG,PDF,TXT,MOV,MP4,CAD'],
      validations: {
        required: false
      }
    }
  },
  components: {
    LmTextInput,
    LmNumberInputV2,
    LmSelect,
    LmSuperPowerSelectV2,
    LmCheckbox
  },
  watch: {
    componentData () {
      this.component = this.componentData
    }
  },
  created () {
    // Obtengo las opciones de extensiones de archivo
    if (process?.env?.VUE_APP_FILE_EXTENSIONS_OPTIONS) {
      const extensions = process?.env?.VUE_APP_FILE_EXTENSIONS_OPTIONS.split(',')
      const extOptions = []
      for (const [index, ext] of extensions.entries()) {
        extOptions.push({
          id: index,
          name: ext
        })
      }
      this.fileExtensionsOptions = extOptions
    }
  }
}
</script>
